/**
 * Bunny AI Gateway
 * Security-first AI gateway. One API. Every model. Total protection. All `/v1/_*` endpoints are transparently proxied to the underlying AI Gateway runtime. Use a valid API key in the `Authorization` header.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Expires } from './expires';

export interface ApiKeyCreateRequest {
  name?: string | null;
  user_id?: string | null;
  models?: string[] | null;
  max_budget?: number | null;
  budget_duration?: string | null;
  duration?: string | null;
  expires?: Expires | null;
  tpm_limit?: number | null;
  rpm_limit?: number | null;
  max_parallel_requests?: number | null;
  metadata?: object | null;
  region?: ApiKeyCreateRequest.RegionEnum | null;
}
export namespace ApiKeyCreateRequest {
  export type RegionEnum = 'eu' | 'us' | 'auto';
  export const RegionEnum = {
    eu: 'eu' as RegionEnum,
    us: 'us' as RegionEnum,
    auto: 'auto' as RegionEnum,
  };
}
